// Mock data for OptimHub DSP platform
/* i18n:extract */

export const heroData = {
  title: "Maximisez votre performance",
  subtitle: "avec la technologie Deep Link OptimHub",
  description: "OptimHub est une plateforme DSP spécialisée dans la technologie de deep link qui connecte les marchands avec des consommateurs hautement engagés à travers des placements premium sur Microsoft Network, sites de coupons, BNPL et contenu contextuel.",
  ctaText: "Commencer maintenant",
  secondaryCtaText: "Demander une démo"
};

export const servicesData = [
  {
    id: 1,
    title: "MSN Microsoft Network",
    description: "Accédez à l'écosystème Microsoft avec des placements sur Outlook, Bing Search, Edge Shopping et MSN Start. Touchez des audiences qualifiées sur des plateformes de confiance mondiale.",
    icon: "Monitor",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwYWR2ZXJ0aXNpbmd8ZW58MHx8fHwxNzU4MjcwMTQzfDA&ixlib=rb-4.1.0&q=85",
    features: ["Outlook Desktop & Mobile", "Bing Search & Shopping", "Edge Tiles & Shopping"]
  },
  {
    id: 2,
    title: "Coupon & Deals",
    description: "Placez votre marque sur les sites de coupons et promotions fréquentés par des consommateurs en phase finale d'achat. Idéal pour capturer l'intention d'achat élevée.",
    icon: "Tag",
    image: "https://images.unsplash.com/photo-1616418625172-c607e16733ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwYWR2ZXJ0aXNpbmd8ZW58MHx8fHwxNzU4MjcwMTQzfDA&ixlib=rb-4.1.0&q=85",
    features: ["Sites de coupons premium", "Audiences haute intention", "Placement brand-safe"]
  },
  {
    id: 3,
    title: "Commerce Content",
    description: "Intégrez vos publicités dans du contenu contextuel pertinent sur des blogs, sites d'actualités et plateformes de contenu pour une expérience utilisateur optimale.",
    icon: "FileText",
    image: "https://images.unsplash.com/photo-1611926653458-09294b3142bf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwYWR2ZXJ0aXNpbmd8ZW58MHx8fHwxNzU4MjcwMTQzfDA&ixlib=rb-4.1.0&q=85",
    features: ["Contenu contextuel", "Audiences niche", "Intégration native"]
  },
  {
    id: 4,
    title: "Buy Now Pay Later (BNPL)",    
    description: "Atteignez des consommateurs avec un pouvoir d'achat élevé sur les plateformes de financement comme Klarna, Afterpay, et ZIP. Parfait pour des AOV élevés.",
    icon: "CreditCard",
    image: "https://images.unsplash.com/photo-1589401199816-4481b05b64f9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxiYW5uZXIlMjBhZHZlcnRpc2luZ3xlbnwwfHx8fDE3NTgyNzAxNjV8MA&ixlib=rb-4.1.0&q=85",
    features: ["Klarna, Afterpay, ZIP", "AOV élevés", "Audiences qualifiées"]
  },
  {
    id: 5,
    title: "Browser Autocomplete",
    description: "Captez l'intention de recherche en temps réel avec des suggestions intelligentes dans l'autocomplétion des navigateurs. Maximisez la visibilité au moment clé.",
    icon: "Search",
    image: "https://images.unsplash.com/photo-1702047054352-cf264d3b1a9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxhZHZlcnRpc2luZyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzU4MjcwMTU5fDA&ixlib=rb-4.1.0&q=85",
    features: ["Intent en temps réel", "Première impression", "Taux de conversion élevé"]
  },
  {
    id: 6,
    title: "Deep Link Technology",
    description: "Technologie propriétaire OptimHub pour monétiser les deep links et connecter directement les consommateurs aux pages produits les plus pertinentes.",
    icon: "Link",
    image: "https://images.unsplash.com/photo-1733681198831-eb4b838c6f77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxiYW5uZXIlMjBhZHZlcnRpc2luZ3xlbnwwfHx8fDE3NTgyNzAxNjV8MA&ixlib=rb-4.1.0&q=85",
    features: ["Technologie propriétaire", "Deep link bidder", "Ciblage contextuel"]
  }
];

export const statsData = [
  {
    label: "Deep Links générés mensuellement",
    value: "10M+",
    unit: ""
  },
  {
    label: "Taux de conversion moyen",
    value: "12",
    unit: "%"
  },
  {
    label: "Partenaires premium",
    value: "200+",
    unit: ""
  },
  {
    label: "Clients nous faisant confiance",
    value: "10000+",
    unit: ""
  }
];

export const testimonialsData = [
  {
    id: 1,
    content: "OptimHub a révolutionné notre approche du commerce media. Leur technologie de deep link nous permet d'atteindre des consommateurs au moment exact de leur intention d'achat.",
    author: "Marie Dubois",
    company: "Fashion E-commerce",
    role: "Directrice Marketing"
  },
  {
    id: 2,
    content: "Les placements sur Microsoft Network via OptimHub nous donnent accès à des audiences qualifiées que nous n'arrivions pas à toucher auparavant. ROI exceptionnel.",
    author: "Alexandre Martin",
    company: "TechRetail",
    role: "Media Buyer"
  },
  {
    id: 3,
    content: "La combinaison BNPL et deep link d'OptimHub a augmenté notre AOV de 40%. Parfait pour nos campagnes premium avec des consommateurs à fort pouvoir d'achat.",
    author: "Sophie Leroux",
    company: "Luxury Brands",
    role: "Responsable Acquisition"
  }
];

export const benefitsData = [
  {
    title: "Modèle CPC vers CPA",
    description: "Nous achetons le trafic au CPC et vous ne payez qu'au CPA - zéro risque, maximum de résultats",
    icon: "TrendingUp"
  },
  {
    title: "Traffic Brokers Experts", 
    description: "Notre expertise en tant que courtiers en trafic garantit l'optimisation continue de vos campagnes",
    icon: "Users"
  },
  {
    title: "Payez uniquement les résultats",
    description: "Modèle révolutionnaire : vous ne payez que pour les conversions réelles, pas pour les clics",
    icon: "Target"
  },
  {
    title: "Transparence totale",
    description: "Accès complet aux données de performance et aux métriques en temps réel",
    icon: "Eye"
  },
  {
    title: "Technologie Deep Link",
    description: "Notre technologie propriétaire de deep link maximise les conversions",
    icon: "Link"
  },
  {
    title: "Support expert",
    description: "Équipe dédiée d'experts en programmatique pour maximiser vos résultats",
    icon: "Shield"
  }
];

export const contactFormFields = [
  {
    name: "firstName",
    label: "Prénom",
    type: "text",
    required: true,
    placeholder: "Votre prénom"
  },
  {
    name: "lastName",
    label: "Nom",
    type: "text",
    required: true,
    placeholder: "Votre nom"
  },
  {
    name: "email",
    label: "Email professionnel",
    type: "email",
    required: true,
    placeholder: "votre.email@entreprise.com"
  },
  {
    name: "company",
    label: "Entreprise",
    type: "text",
    required: true,
    placeholder: "Nom de votre entreprise"
  },
  {
    name: "role",
    label: "Fonction",
    type: "text",
    required: false,
    placeholder: "Votre fonction"
  },
  {
    name: "budget",
    label: "Budget publicitaire mensuel",
    type: "select",
    required: true,
    options: [
      { value: "", label: "Sélectionnez votre budget" },
      { value: "under-10k", label: "Moins de 10 000€" },
      { value: "10k-50k", label: "10 000€ - 50 000€" },
      { value: "50k-100k", label: "50 000€ - 100 000€" },
      { value: "100k-500k", label: "100 000€ - 500 000€" },
      { value: "over-500k", label: "Plus de 500 000€" }
    ]
  },
  {
    name: "message",
    label: "Message",
    type: "textarea",
    required: false,
    placeholder: "Décrivez votre projet ou vos objectifs publicitaires..."
  }
];
/* i18n:end */
